import { Table } from "react-bootstrap";
import { changeDateFormatForDisplay } from "../../Utils/dateUtils";
import MainLoader from "../_widgets/Loader/MainLoader";
import NavBar from "../_widgets/NavBar/NavBar";
import CustomPagination from "../_widgets/Pagination/Pagination";
import Text from "../_widgets/Text/Text";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";

const AlertMedicineUI = ({ list, onPageChange, loading, error, type, stock, expiry }) => {
  return (
    <AnimatedPage>
      <NavBar
        heading={
          type === "STOCK"
            ? "Alert Medicine List that has stock <=" + stock
            : "Alert Medicine List whose stock is expiring in " + expiry + " days"
        }
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        Icon="menu"
      />

      <div className="patient_list white_card">
        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : list?.data?.length > 0 ? (
            <>
              <div>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Medicine Name</th>
                      <th>Batch Number</th>
                      <th>Remaining Stock</th>
                      <th>Expiry Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {list?.data?.map((data) => {
                      return (
                        <tr key={data.id}>
                          <td>
                            <Text text={data?.name} />
                          </td>
                          <td>
                            <Text text={data?.batch_number} />
                          </td>
                          <td>
                            <Text text={data?.remaining_stock} />
                          </td>
                          <td>
                            <Text text={changeDateFormatForDisplay(data?.expiry_date)} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <CustomPagination
                activePage={list?.current_page}
                onPageChange={onPageChange}
                pageLength={list?.per_page}
                totalData={list?.total}
                lastPage={list?.last_page}
              />
            </>
          ) : (
            <>
              <div className="no_data position-relative">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text={error} />
              </div>
            </>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default AlertMedicineUI;
